import styled from 'styled-components'

import { media } from '../../../../../styles/breakpoints'
import { blue } from '../../../../../styles/colors'

const LEGEND_ITEMS = [
  { className: 'scan_health_1w', label: '1 week' },
  { className: 'scan_health_2w', label: '2 weeks' },
  { className: 'scan_health_3w', label: '3 weeks' },
  { className: 'scan_health_none', label: 'No recent scan' },
] as const

export const ScanHealthLegend = () => (
  <LegendContainer>
    <LegendItems>
      {LEGEND_ITEMS.map(item => (
        <LegendItem key={item.className}>
          <LegendSwatch className={item.className} />
          <span>{item.label}</span>
        </LegendItem>
      ))}
    </LegendItems>
  </LegendContainer>
)

const LegendContainer = styled.div`
  width: 100%;
`

const LegendItems = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px 12px;

  @media (max-width: 360px) {
    flex-direction: column;
    align-items: flex-start;
  }

  @media ${media.belowTablet} {
    justify-content: flex-start;
  }
`

const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: #686868;
  font-size: 11px;
  line-height: 1.2;
  white-space: nowrap;
`

const LegendSwatch = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  flex-shrink: 0;
  box-sizing: border-box;

  &.scan_health_none {
    background-color: white;
    border: 2px solid #686868;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
  }

  &.scan_health_3w {
    background-color: #a8c8e8;
    border: 2px solid #5a8ab8;
  }

  &.scan_health_2w {
    background-color: #4a7ab8;
    border: 2px solid ${blue};
  }

  &.scan_health_1w {
    background-color: ${blue};
    border: 2px solid ${blue};
  }
`
